import React from 'react';
import { motion } from 'framer-motion';
import { Scale, Database, TrendingUp, ShieldCheck } from 'lucide-react';
const features = [{
  icon: ShieldCheck,
  title: 'Removes Bias',
  description: 'Eliminates human prejudice and focuses purely on data compatibility.'
}, {
  icon: Scale,
  title: 'Scales Decisions',
  description: 'Process thousands of potential matches in seconds, not months.'
}, {
  icon: Database,
  title: 'Learns from Outcomes',
  description: 'Our models get smarter with every successful partnership formed.'
}, {
  icon: TrendingUp,
  title: 'Continuous Improvement',
  description: 'The more the platform is used, the better the matches become.'
}];
export function WhyAI() {
  return <section className="py-24 bg-slate-900 relative overflow-hidden" data-id="element-945">
      {/* Background Elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-cyan-900/10 to-transparent pointer-events-none" data-id="element-946"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-947">
        <div className="text-center mb-16" data-id="element-948">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-949">
            Because humans are emotional. <br data-id="element-950" />
            <span className="text-cyan-500" data-id="element-951">AI is objective.</span>
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-952">
            SponsrAI brings data-driven clarity to a relationship-driven
            industry.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-953">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-800/30 border border-slate-700 p-6 rounded-xl hover:bg-slate-800/50 transition-all" data-id="element-954">
              <div className="w-12 h-12 bg-cyan-500/10 rounded-lg flex items-center justify-center mb-4 text-cyan-400" data-id="element-955">
                <feature.icon size={24} data-id="element-956" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-957">
                {feature.title}
              </h3>
              <p className="text-slate-400 text-sm" data-id="element-958">{feature.description}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}